import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
// import reportWebVitals from './reportWebVitals';
const divAppointment = document.createElement('div')
divAppointment.id = "coach-appointment-widget"
divAppointment.setAttribute("hideButton", true)
const elem = document.getElementById('coach-appointment-widget')

const script = document.createElement('script');
script.src = "https://checkout.razorpay.com/v1/checkout.js"
document.head.appendChild(script)


const headID = document.getElementsByTagName('head')[0];
const link = document.createElement('link');
link.type = 'text/css';
link.rel = 'stylesheet';
link.href = "https://fonts.googleapis.com/icon?family=Material+Icons"
const link2 = document.createElement('link');
link2.type = 'text/css';
link2.rel = 'stylesheet';
link2.href = "https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap"
headID.appendChild(link);
headID.appendChild(link2);

// const coachID = "b0dc7681-4c97-46c5-a962-194d07aba833"
// const subscriptionID = "7e9697fb-f5ea-4837-8b7d-a1049c97e8ec"
const useCase = "embedd"
const coachID = elem.getAttribute('coachId')
const subscriptionID = elem.getAttribute('subscriptionId')
// const useCase = elem.getAttribute('useCase')

const hideButton = elem.getAttribute('hideButton')

if (useCase !== 'embedd') {
  elem.setAttribute("style", "position:fixed;bottom:5px;right:5px;overflow:auto;z-index: 2147483647;");
}

ReactDOM.render(
  <React.StrictMode>
    <App coachID={coachID} subscriptionID={subscriptionID} useCase={useCase} hideButton={hideButton} />
  </React.StrictMode>,
  elem
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
